import React from "react";
import Joi from "joi-browser";
import Form from "./common/form";
import firebase, { usersRef } from "../services/firebaseconn";
import { getGenders } from "../services/genderService";
import { getGrades } from "../services/gradeService";
import { getFields } from "../services/fieldService";
import { sortList } from "../components/common/helpers";
import { getUser, updateUser } from "../services/userService";
import moment from "moment";
import _ from "underscore";
import { Switch } from "antd";

// const USERNAME = "Pseudônimo";
// const FIRST_NAME = "Primeiro nome";
// const LAST_NAME = "Último nome"
const BIRTHDATE = "Data de nascimento";
const GENDER = "Sexo";
const GRADE = "Nível académico";
const FIELD = "Curso";
// const INSTITUTE = "Instituição";

const EDIT = "Editar";
const SAVE = "Salvar";

class ProfileForm extends Form {
  state = {
    edit: false,
    currentUser: {},
    fields: {},
    data: {
      // userName: "",
      birthdate: new Date(),
      gender: "",
      grade: undefined,
      field: "",
      // institute: ""
    },
    errors: {},
    unsubscribeUser: undefined,
  };

  populateCurrentUser(currentUser) {
    // const currentUser = this.state.currentUser;
    const data = { ...this.state.data };
    // if (currentUser.userName) data.userName = currentUser.userName;
    if (currentUser.birthdate)
      data.birthdate = new Date(currentUser.birthdate.toDate());
    if (currentUser.gender) data.gender = currentUser.gender;
    if (currentUser.grade) data.grade = currentUser.grade;
    if (currentUser.field) data.field = currentUser.field;
    if (currentUser.institute) data.institute = currentUser.institute;

    return data;
  }

  componentDidMount() {
    const unsubscribeUser = firebase.auth().onAuthStateChanged(async (user) => {
      if (user && user.email) {
        try {
          const currentUser = await getUser(user.email);
          if (!currentUser) return (window.location = "/logout");
          const fields = await getFields();
          const data = this.populateCurrentUser(currentUser);

          let edit = false;
          if (this.props.location.state && this.props.location.state.newUser)
            edit = true;
          this.setState({ data, currentUser, fields, edit });
        } catch (err) {
          console.log(err);
          return (window.location = "/logout");
        }
      } else {
        return (window.location = "/login");
      }
    });
    this.setState({ unsubscribeUser });
  }
  componentWillUnmount() {
    this.state.unsubscribeUser();
  }

  schema = {
    // userName: Joi.string().required().label(USERNAME),
    // firstName: Joi.string().required().label(FIRST_NAME),
    // lastName: Joi.string().required().label(LAST_NAME),
    birthdate: Joi.date()
      .max(new Date().setDate(new Date().getDate() - 1))
      .required()
      .label(BIRTHDATE),
    gender: Joi.string().valid("M", "F").required().label(GENDER),
    grade: Joi.number().required().label(GRADE),
    field: Joi.string().allow(null, "").label(FIELD),
    // institute: Joi.string().label(INSTITUTE)
  };

  doSubmit = async () => {
    this.setState({ edit: false });
    const data = { ...this.state.data };
    const currentUser = { ...this.state.currentUser };

    try {
      await updateUser(currentUser.email, data);

      const updatedUser = (await usersRef.doc(currentUser.email).get()).data();
      this.setState({ currentUser: updatedUser });
      if (this.props.location.state && this.props.location.state.newUser)
        return this.props.history.replace({
          pathname: "/home",
          state: { newUser: true },
        });
    } catch (err) {
      console.log(err.message);
    }
  };

  render() {
    const { edit, currentUser, fields } = this.state;
    let newUser;
    if (this.props.location.state && this.props.location.state.newUser)
      newUser = true;
    else newUser = false;

    return (
      <div>
        <h3>Dados do usuário </h3>
        <p>
          {currentUser.email ? (
            <>
              <i className="fa fa-envelope" aria-hidden="true" />
              {currentUser.email}
            </>
          ) : null}
          {/* {"   "}
          {currentUser.userName ? (
            <>
              <i className="fa fa-user" aria-hidden="true" />
              {currentUser.userName}
            </>
          ) : null} */}
        </p>

        {!newUser ? (
          <>
            <label htmlFor="edit">{EDIT}</label>
            <Switch
              name="edit"
              checked={this.state.edit}
              onChange={(checked, event) => {
                const newState = { ...this.state };
                newState.data = { ...this.state.data };
                newState.edit = checked;

                if (!checked) {
                  const data = this.populateCurrentUser(currentUser);
                  newState.data = data;
                }
                this.setState(newState);
              }}
            />
          </>
        ) : null}

        <form onSubmit={this.handleSubmit}>
          {/* {this.renderInput("userName", USERNAME, !edit)} */}
          {/* {this.renderInput("firstName", FIRST_NAME)}
                    {this.renderInput("lastName", LAST_NAME)} */}
          {this.renderDatePicker(
            "birthdate",
            BIRTHDATE,
            new Date(),
            function (current) {
              return current > moment().endOf("day");
            },
            !edit
          )}
          {this.renderSelect("gender", GENDER, getGenders(), !edit)}
          {this.renderSelect("grade", GRADE, getGrades(), !edit)}
          {this.renderSelect("field", FIELD, sortList(_.values(fields)), !edit)}
          {/* {this.renderInput("institute", INSTITUTE, !edit)} */}

          {this.renderButton(SAVE, !edit)}

          {newUser ? (
            <button
              className="btn btn-primary"
              style={{ marginBottom: 20, marginLeft: 20 }}
              onClick={(e) => {
                e.preventDefault();
                this.props.history.replace({
                  pathname: "/home",
                  state: { newUser: true },
                });
              }}
            >
              Configurar perfil mais tarde
            </button>
          ) : null}
        </form>
      </div>
    );
  }
}

export default ProfileForm;
